import merge from 'lodash/merge';

import { createAxiosInstance } from '@/apis/axios.utils';
import { env } from '@/env';

export const axios = createAxiosInstance(env.integrationApiUrl, {
  camelizeKeys: true,
});

export default {
  async getSalesforceCaseFields(brandId, axiosConfig = {}) {
    return axios.get('/salesforce/case_fields', merge({ params: { brandId } }, axiosConfig));
  },
  async getSalesforceMappings(brandId, axiosConfig = {}) {
    return axios.get('/salesforce/mappings', merge({ params: { brandId } }, axiosConfig));
  },
  async createOrReplaceSalesforceMappings(data, axiosConfig = {}) {
    return axios.put('/salesforce/mappings', data, axiosConfig);
  },
  async getSalesforceCase(brandId, caseId, axiosConfig = {}) {
    return axios.get('/salesforce/cases', merge({ params: { brandId, caseId } }, axiosConfig));
  },
  async getSalesforceAccount(brandIds, axiosConfig = {}) {
    return axios.get('/salesforce/accounts', merge({ params: { brandIds } }, axiosConfig));
  },
  async updateSalesforceMappings(data, axiosConfig = {}) {
    return axios.patch('/salesforce/mappings', data, axiosConfig);
  },
  async createCanvaAsset(data, axiosConfig = {}) {
    return axios.post('/canva/assets', data, axiosConfig);
  },
  async getCanvaAssetJob(jobId, brandId, axiosConfig = {}) {
    return axios.get(`/canva/asset_jobs/${jobId}`, merge({ params: { brandId } }, axiosConfig));
  },
  async createCanvaDesign(data, axiosConfig = {}) {
    return axios.post('/canva/designs', data, axiosConfig);
  },
  async verifyCanvaJwt(data, axiosConfig = {}) {
    return axios.post('/canva/verify_token', data, axiosConfig);
  },
  async createCanvaExport(data, axiosConfig = {}) {
    return axios.post('/canva/exports', data, axiosConfig);
  },
  async getCanvaExportJob(jobId, brandId, axiosConfig = {}) {
    return axios.get(`/canva/export_jobs/${jobId}`, merge({ params: { brandId } }, axiosConfig));
  },
};
